module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: ['ui-data-list', _vm.preset ? ("ui-data-list--" + _vm.preset) : null, _vm.type ? ("ui-data-list--" + _vm.type) : null]
  }, [_c('table', {
    staticClass: "ui-data-list__table"
  }, [(_vm.tableHeader && _vm.tableHeader.length) ? _c('thead', [_c('tr', [(_vm.hasCheckBox) ? _c('th', {
    staticClass: "ui-data-list__col__checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHeader), function(row) {
    return _c('th', [_vm._v(_vm._s(row))])
  }), _vm._v(" "), (typeof _vm.dropdown !== 'undefined') ? _c('th', {
    staticClass: "ui-data-list__col__dropdown no-overflow-hidden"
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.list.length) ? _c('tbody', _vm._l((_vm.cached), function(row, index) {
    return _c('tr', {
      class: [_vm.selectedClass(row, index), !row.onClick ? 'no-click' : ''],
      on: {
        "click": function () { return _vm.onClick(row); }
      }
    }, [(_vm.hasCheckBox) ? _c('td', {
      staticClass: "ui-data-list__col__checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      }
    })]) : _vm._e(), _vm._v(" "), (Array.isArray(row)) ? _vm._l((row), function(column, columnIndex) {
      return _c('td', {
        class: [typeof column === 'number' ? 'monospaced' : '']
      }, [(columnIndex === 0) ? _c('app-icon', {
        attrs: {
          "tools": _vm.tools,
          "name": _vm.preset
        }
      }) : _vm._e(), _vm._v("\n                        " + _vm._s(column) + "\n                    ")], 1)
    }) : _vm._l((row.items), function(column, columnIndex) {
      return _c('td', {
        class: [typeof column === 'number' ? 'monospaced' : '', typeof column === 'object' && column.classes ? column.classes : null]
      }, [(columnIndex === 0) ? _c('app-icon', {
        attrs: {
          "tools": _vm.tools,
          "name": _vm.preset
        }
      }) : _vm._e(), _vm._v("\n                        " + _vm._s((column && column.text) ? column.text : column) + "\n                    ")], 1)
    }), _vm._v(" "), (typeof _vm.dropdown !== 'undefined') ? _c('td', {
      staticClass: "ui-data-list__col__dropdown no-overflow-hidden"
    }, [_c('ui-dropdown', {
      attrs: {
        "list": _vm.dropdown(row)
      }
    })], 1) : _vm._e()], 2)
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e897b1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/UiDataList.vue
// module id = 430
// module chunks = 1